export default function getServerURL() {
  if (process.env.REACT_APP_MODE === "DEV") {
    return `http://localhost${process.env.REACT_APP_URL}`
  }
  return `${process.env.REACT_APP_URL_PREFIX}${window.location.host.split(".")[0]}${process.env.REACT_APP_URL}`
}



// WEBPACK FOOTER //
// ./src/functions/getServerURL.js